import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { replaceByElement } from "../../../../../utils/Logs";

interface IProps {
  employee: string;
  employeeId: string;
}

export default function EmployeeSuccessfullyLinkedWithAnAppUser(props: IProps) {
  const { employee, employeeId } = props;
  const { t } = useTranslation();

  const employeeName = useMemo(
    () => employee ?? employeeId,
    [employee, employeeId]
  );

  return useMemo(
    () =>
      replaceByElement(
        t("log.successfully_logged_into_app"),
        "{employee}",
        employeeName
      ),
    [employeeName, t]
  );
}
